module.exports = __webpack_public_path__ + "img/plate01_07.8392f71f.png";